export class Csp5070Class {
    UserNam: string;
}
